<!-- Keeps the `.ui-header-action` classes so the control inherits the header's
     44px square, border, hover wash and active treatment unchanged. -->
<button
  type="button"
  class="ui-header-action"
  [class.ui-header-action--active]="active"
  [attr.aria-label]="'common.filter' | translate"
  [matTooltip]="'common.filter' | translate"
  matTooltipPosition="below"
  (click)="filter.emit()"
>
  <img src="assets/icones/filter_icon.svg" alt="" />
</button>

<!-- Clear badge. Rendered as a sibling rather than a child so the markup stays
     valid, and positioned over the button's top-right corner by the SCSS. -->
<button
  *ngIf="active"
  type="button"
  class="filter-action__clear"
  [attr.aria-label]="'common.clear_filters' | translate"
  [matTooltip]="'common.clear_filters' | translate"
  matTooltipPosition="below"
  (click)="onClear($event)"
>
  <!-- ui-icon, not the clear-icon.svg asset: that file hardcodes
       stroke="white", which is invisible on anything but a dark fill. Lucide
       inherits currentColor, so the badge colours it from the CSS below. -->
  <ui-icon name="X" [pxSize]="10"></ui-icon>
</button>
